import styled from 'styled-components';
import { rem } from 'polished';

const InputContainer = styled.div`
    margin-right: ${rem(16)};
    min-width: ${rem(120)};
`;

export default InputContainer;
